import { Component } from './component';

export class Store extends Component {
  readonly __isStore = true;
  readonly __injectable = true;
}
